<div *ngIf="print.load" class="body-wrapper" style="direction: rtl; padding-top: 0">
    <header class="header">
      <div class="justify-between items-center" style="margin-bottom: 5px;text-align: center;margin-bottom: 3%;">
        <!-- <h1 class="header-title">{{'exam.type.GYNE.'+print.exam.ExamType | translate}}</h1> -->
        <h1 class="header-title"> פירוט תורים יומיים של: {{print.doctorInfo.Title}}  {{print.doctorInfo.Name}}</h1>
      </div>
      <div class="header-details">
        <div style="display: inline-block; padding-left: 1em;">
          תאריך התורים:&nbsp;<strong style='direction: ltr;'>{{startDate | date:"dd.MM.yyyy"}}</strong>
        </div>
        <div style="display: inline-block">
          תאריך הדפסה:&nbsp;<strong style='direction: ltr;'>{{now| date:"dd.MM.yyyy HH:mm"}}</strong>
        </div>
      </div>
    </header>
    <main class="main">
        <section class="section marginBottom" *ngIf="print.appointments && print.appointments.length">
            <!-- <h2> תורים</h2> -->
            <table class="l-table-auto weightAss-table">
                <tr class="l-row weightAss-thead">
                    <td class="l-td-m" style="width: 5%;">#</td>
                    <td class="l-td-m" style="width: 15%;font-weight: 700;">שעות התור </td>
                    <td class="l-td-m" style="width: 15%;font-weight: 700;">שם התור </td>
                    <td class="l-td-m" style="width: 15%;font-weight: 700;">סוג הבדיקה  </td>
                    <td class="l-td-m" style="width: 15%; font-weight: 700;">שם המטופל/ת </td>
                    <td class="l-td-m" style="width: 15%;font-weight: 700;"> תז </td>
                    <td class="l-td-m" style="width: 15%;font-weight: 700;"> טלפון </td>
                </tr>
                <br> <ng-container *ngFor="let appointment of print.appointments | sortByDateTime;index as i">
                    <tr class="l-row weightAss-tbody">
                        <td class="l-td-m" style="width: 5%;">{{i+1}}</td>
                        <td class="l-td-m" style="width: 15%;">{{ appointment.aptTime | date:"HH:mm" }}-{{ appointment.aptEndTime | date:"HH:mm" }}</td>
                        <td class="l-td-m" style="width: 15%;">{{appointment.examName}}</td>
                        <td class="l-td-m" style="width: 15%;">{{appointment.Type}}</td>
                        <td class="l-td-m" style="width: 15%;">{{appointment.First}} {{appointment.Last}}</td>
                        <td class="l-td-m" style="width: 15%;">{{appointment.ID}}</td>
                        <td class="l-td-m" style="width: 15%;">{{appointment.Mobile}}</td>
                    </tr>
                </ng-container> 
            </table>
        </section>
    </main>
</div>

